// extracted by mini-css-extract-plugin
module.exports = {"HomeContent":"homeContent_HomeContent__3VlQ6","content-image":"homeContent_content-image__230wd","content-text":"homeContent_content-text__1puwS"};